import { styled } from "@mui/material/styles";
import { TextField as MuiTextField } from "@mui/material";

export const TextField = styled(MuiTextField)({
  marginTop: "10px",

  "& input.MuiInputBase-input.Mui-disabled": {
    textFillColor: "rgba(0, 0, 0, 0.87)",
  },

  "& .MuiInputAdornment-root.MuiInputAdornment-positionEnd > .MuiButtonBase-root": {
    padding: "7px",
    fontSize: "20px",
    visibility: "hidden",
    opacity: 0,
    transition: "all .3s ease",
  },

  "&:hover .MuiInputAdornment-root.MuiInputAdornment-positionEnd > .MuiButtonBase-root": {
    visibility: "visible",
    opacity: 1,
  },
});
